import { render, staticRenderFns } from "./Supportes.vue?vue&type=template&id=8460f512"
import script from "./Supportes.vue?vue&type=script&lang=js"
export * from "./Supportes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports